export default "__VITE_ASSET__5MlwfLRS__"